import { View } from '../../manager';
import { useGlobalStateRef } from './use-global-state';

const SKIP_LAZY_LOAD_FOR_TYPES = new Set([
  'frame',
  'section',
  'image',
  'shape',
  'text',
  '1QRRiAt1Js1nD0ApT2Ek_Slideshow',
  '4m4woXHPJqnEyfmHuuf1_Slideshow',
  'H9ZDY2XDPnfJpielBq1o_ScrollingSlide',
  'd4C9FTH9nDHZcMZLFXpO_ScrollingSlide',
]);

export function useLazyLoadElement(type: string | undefined) {
  const [stateRef] = useGlobalStateRef();

  if (!type || SKIP_LAZY_LOAD_FOR_TYPES.has(type || '')) return false;

  const lazyLoadSettings = stateRef.current.settings?.load;
  return (lazyLoadSettings === 'lazy-ios' && View.isIOS) || lazyLoadSettings === 'lazy';
}
